// Route root of the eCourts pages — keep in sync with App.js and Navbar.js
export const EC_ROOT = '/ecourt';
export const ecPath = (p) => (p ? `${EC_ROOT}/${p}` : EC_ROOT);
export const CNR_RE = /^[A-Z]{4}\d{12}$/;
export const normalizeCnr = (v) => String(v || '').trim().toUpperCase().replace(/\s+/g, '');
export const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

/** ₹ amount with 2 decimals. */
export const money = (n) => `₹${(Number(n) || 0).toFixed(2)}`;

export function fmtDate(iso) {
  if (!iso) return '—';
  const [y, m, d] = String(iso).slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return String(iso);
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' });
}

export function caseTitle(c) {
  const p = (c && c.petitioners && c.petitioners.join(', ')) || 'Unknown';
  const r = (c && c.respondents && c.respondents.join(', ')) || 'Unknown';
  return `${p} vs ${r}`;
}

export function statusBadge(status) {
  return String(status || '').toUpperCase() === 'PENDING' ? 'ec-badge ec-badge-blue' : 'ec-badge ec-badge-grey';
}

export function parseCnrText(text) {
  const seen = new Set();
  const valid = [];
  const invalid = [];
  let duplicates = 0;
  String(text || '').split(/[\s,]+/).forEach((item) => {
    const c = normalizeCnr(item);
    if (!c) return;
    if (seen.has(c)) { duplicates += 1; return; }
    seen.add(c);
    (CNR_RE.test(c) ? valid : invalid).push(c);
  });
  return { valid, invalid, duplicates };
}

/** One line for a change on a saved case (My Cases updates). */
export function updateText(u) {
  const d = (u && u.details) || {};
  switch (u && (u.event_type || u.type)) {
    case 'new_order': return `New order${d.count > 1 ? `s (${d.count})` : ''}${d.orderDate ? ` dated ${fmtDate(d.orderDate)}` : ''}`;
    case 'date_changed': return `Hearing date moved${d.from ? ` from ${fmtDate(d.from)}` : ''} to ${fmtDate(d.to)}`;
    case 'ia_filed': return `${d.count || 1} new interim application${d.count > 1 ? 's' : ''} filed`;
    case 'transferred': return `Case transferred${d.to ? ` to ${d.to}` : ''}`;
    case 'disposed': return 'Case disposed';
    default: return 'Case updated';
  }
}